/* import React from 'react'

const ListCategorie = () => {
  return (
    <div>ListCategorie</div>
  )
}

export default ListCategorie */

import React, { useEffect, useState } from "react";
import { Table, Form, Select, Button, Space, Row, Col, Tooltip, Input } from "antd";
import "../Pages/CSS/DonnesBases.css";
import { GestionPaieService } from "../Services/GestionPaieService";
import { DeleteFilled } from "@ant-design/icons";
import confirm from "antd/es/modal/confirm";
const { Option } = Select;
const ListCategorie = () => {
  const [form] = Form.useForm();
  const [editing, setEditing] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [comptes, setComptes] = useState([]);
  const [pageSize, setPageSize] = useState(10)
  const [conventions, setConventions] = useState([]);
  const gestionPaieService = new GestionPaieService();
  const userProfil = localStorage.getItem("profil");

  const fetchAllData = async () => {
    try {
      const modelisation = await gestionPaieService.getAllCategorie();
      setTableData(modelisation);
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  const fetchConv = async () => {
    try {
      const response = await gestionPaieService.getAllConv();
      setConventions(response);
    } catch (error) {
      console.error("Erreur lors de la récupération des périodes :", error);
    }
  };

 

  useEffect(() => {
    fetchAllData(); 
    fetchConv(); 
  
  }, []);
  

  const handleUpdate = async () => {
    // Récupérer les valeurs actuelles du formulaire
    const values = await form.validateFields();
    const selectedConv = conventions.find(conv => conv.codeconv === values.codeconv);
    const payload = {
      codecateg: values.codecateg,
      valcateg: values.valcateg,
      codeconv: values.codeconv,
      libconv: selectedConv ? selectedConv.libconv : null,
    };
  
    try {
      const updatedData = await gestionPaieService.updateCateg(payload);
      // Mettre à jour les données du tableau avec les nouvelles données
      const updatedTableData = tableData.map((item) => {
        if (item.codecateg === payload.codecateg && item.valcateg === payload.valcateg) {
          return { ...item, ...updatedData };
        }
        return item;
      });
      setTableData(updatedTableData);
      await fetchAllData();
      setEditing(false); 
      form.resetFields(); 
    } catch (error) {
      console.error('Erreur lors de la mise à jour :', error);
    }
  };
  
  const handleAddModelisation = async () => {
    try {
      const values = await form.validateFields();
      const selectedConv = conventions.find(conv => conv.codeconv === values.codeconv);
    const payload = {
      codecateg: values.codecateg,
      valcateg: values.valcateg,
      codeconv: values.codeconv,
      libconv: selectedConv ? selectedConv.libconv : null,
    };
  
      const response = await gestionPaieService.addCateg(payload);
      
      await fetchAllData();
      setEditing(false); 
      form.resetFields(); 
    } catch (error) {
      console.error('Erreur lors de la validation ou de l’ajout de données :', error);
      // Pas besoin de lancer d'autres logiques, car form.validateFields() a échoué
    }
  };

  const handleDelete = async (codecateg) => {
    try {
      await gestionPaieService.deleteCateg(codecateg);
      // Rafraîchir les données après la suppression
      await fetchAllData();
      form.resetFields();
      setEditing(false);
    } catch (error) {
      console.error("Erreur lors de la suppression :", error);
    }
  };

  /* const columns = [
    {
      title: "Code",
      dataIndex: "codecateg",
      key: "codecateg",
    
    },
    {
      title: "Valeur",
      dataIndex: "valcateg",
      key: "valcateg",
      
    },
    {
      title: "Convention",
      dataIndex: "libconv",
      key: "libconv",
      align : "center"
    },
    ...(userProfil !== 'role_15' && userProfil !== 'role_3' && userProfil !== 'role_4' && userProfil !== 'role_5' ? [
      { 
        title: (
            <div
              style={{
                backgroundColor: "#010f1c",
                color: "white",
                padding: "1px",
              }}
            ></div>
          ),
         
          align: "center",
          fixed: "right", // Fixe la colonne à droite
          render: (text, record) => (
            <span> 
                <Tooltip title="Supprimer">
                  <DeleteFilled style={{ cursor: "pointer", color: "red" }}   onClick={() => handleDelete(record.codecateg)}/>
                </Tooltip>
             
            </span>
          ),
        },
      ] : []),
    ].filter(column => column);
 */

    const columns = [
      {
        title: "Code",
        dataIndex: "codecateg",
        key: "codecateg",
        sorter: (a, b) => a.codecateg.localeCompare(b.codecateg),
      },
      {
        title: "Valeur",
        dataIndex: "valcateg",
        key: "valcateg",
        sorter: (a, b) => a.valcateg.localeCompare(b.valcateg),
      },
      {
        title: "Convention",
        dataIndex: "libconv",
        key: "libconv",
       // align: "center",
        sorter: (a, b) => a.libconv.localeCompare(b.libconv),
      },
      ...(userProfil !== 'role_15' && userProfil !== 'role_3' && userProfil !== 'role_4' && userProfil !== 'role_5'
        ? [
            {
              title: (
                <div
                  style={{
                    backgroundColor: "#010f1c",
                    color: "white",
                    padding: "1px",
                  }}
                ></div>
              ),
              align: "center",
              fixed: "right",
              render: (text, record) => (
                <span>
                  <Tooltip title="Supprimer">
                    <DeleteFilled
                      style={{ cursor: "pointer", color: "red" }}
                      onClick={() => handleDelete(record.codecateg)}
                    />
                  </Tooltip>
                </span>
              ),
            },
          ]
        : []),
    ].filter((column) => column);
    
  const onRowClick = (record) => {
    form.setFieldsValue({
      codecateg: `${record.codecateg} `,
      valcateg: `${record.valcateg} `,
      codeconv: record.codeconv,
    });
    setEditing(true);
  };

  const handleCancel = () => {
    form.resetFields();
    setEditing(false);
  };

  return (
    <div>
       {userProfil !== 'role_15' && userProfil !== 'role_3' && userProfil !== 'role_4' && userProfil !== 'role_5' && (
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={4}>
            <Form.Item
             name="codecateg"
             label="Code"
             rules={[
              { required: true, message: "Le code est obligatoire" },
              
            ]}
             >
            <Input
                bordered={false}
                style={{ borderBottom: "2px solid #030303" }}
              />
            </Form.Item>
           
          </Col>
          <Col span={4}>
           
            <Form.Item
             name="valcateg"
             label="Valeur"
             rules={[
              { required: true, message: "La valeur est obligatoire" },
              
            ]}
             >
            <Input
                bordered={false}
                style={{ borderBottom: "2px solid #030303" }}
              />
            </Form.Item>
           
          </Col>
          <Col span={10}>
            <Form.Item name="codeconv" label="Convention"  
             rules={[
              { required: true, message: "La convention est obligatoire" },
              
            ]}>
              <Select
                placeholder="Sélectionnez un sens"
                bordered={false}
                style={{ borderBottom: "2px solid #030303" }}
                showSearch
                filterOption={(input, option) =>
                  option.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
               {conventions.map((conv) => (
                  <Option key={conv.codeconv} value={conv.codeconv}>
                    {`${conv.libconv}`} 
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6} style={{ display: "flex", justifyContent: "right" }}>
            {editing ? (
              <Space>
                <Button
                  style={{ marginTop: 10}}
                  type="primary"
                  onClick={handleUpdate}
                  htmlType="submit"
                >
                  Modifier
                </Button>
                <Button   style={{ marginTop: 10}} onClick={handleCancel}>
                  Annuler
                </Button>
              </Space>
            ) : (
                <Space>
              <Button
              style={{ marginTop: 10}}
                type="primary"
                htmlType="submit"
                onClick={handleAddModelisation}
              >
                Enregistrer
              </Button>
              </Space>
            )}
          </Col>
        </Row>
      </Form>
       )}
      <Table
        dataSource={tableData}
        columns={columns}
        showSorterTooltip={false}
        scroll={{
          x: true,
        }}
        style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
        className="custom-header1-table"
        bordered
        onRow={(record) => ({
          onClick: () => onRowClick(record),
        })}
        pagination={{
          pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
          showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
          pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
          onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
        }}
      />
    </div>
  );
};

export default ListCategorie;
